var map = {
	"./music-instructions.json": 4429,
	"./music-library-intro2024.json": 4430,
	"./music-library-launch2024.json": 4431,
	"./music-progression.json": 4432,
	"./startSourcesAdvanced.json": 4433,
	"./startSourcesSimple.json": 4434,
	"./startSourcesSimple2.json": 4435,
	"./startSourcesTracks.json": 4436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4166;